// extracted by mini-css-extract-plugin
module.exports = {"root":"src-components-results-Hotel-Carousel-TripadvisorReviews-styles-index__root","more":"src-components-results-Hotel-Carousel-TripadvisorReviews-styles-index__more"};